import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DianService } from '@app/services/dian.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-software-form',
  templateUrl: './software-form.component.html',
  styleUrls: ['./software-form.component.css']
})
export class SoftwareFormComponent {
  @Input() id: number;
  @Input() set dataSoft(value: any[]) {
    this._dataSoft = value;
    this.onDataResolutionChange();
  }
  get dataSoft(): any[] {
    return this._dataSoft;
  }
  private _dataSoft: any[] = [];
  exists: boolean = false;
  softwareForm!: FormGroup;

  constructor(private fb: FormBuilder, private dianService: DianService) {
    this.softwareForm = this.fb.group({
      typeSoftwareId: [0],
      identifier: ['', [Validators.required, Validators.minLength(3)]],
      pin: ['', [Validators.required, Validators.minLength(4)]],
      url: ['', [Validators.required, Validators.pattern(/https?:\/\/.+/)]]
    });
  }

  onDataResolutionChange(): void {
    this.softwareForm.reset();
    if (this.dataSoft) {
      this.softwareForm.patchValue(this.dataSoft);
      this.exists = true;
    }
  }

  post(): void {
    if (this.softwareForm.valid) {
      let data = this.softwareForm.getRawValue();
      this.dianService.postSoftware(data).subscribe(
        resp => {
          Swal({
            type: 'success',
            title: '¡Operación exitosa!',
            text: 'El software se ha registrado correctamente.'
          });
        },
        error => {
          Swal({
            type: 'error',
            title: 'Error',
            text: 'Ocurrió un error al registrar el software.'
          });
        }
      );
    } else {
      Swal({
        type: 'warning',
        title: 'Formulario inválido',
        text: 'Por favor, completa todos los campos requeridos.'
      });
    }
  }

  put(): void {
    if (this.softwareForm.valid) {
      let data = this.softwareForm.getRawValue();
      this.dianService.putSoftware(data, this.id).subscribe(
        resp => {
          Swal({
            type: 'success',
            title: '¡Actualización exitosa!',
            text: 'El software se ha actualizado correctamente.'
          });
        },
        error => {
          Swal({
            type: 'error',
            title: 'Error',
            text: 'Ocurrió un error al actualizar el software.'
          });
        }
      );
    } else {
      Swal({
        type: 'warning',
        title: 'Formulario inválido',
        text: 'Por favor, completa todos los campos requeridos.'
      });
    }
  }
}
